module.exports = __webpack_public_path__ + "img/icon-vot-addcategory.a0639c09.png";